import { Features } from "byzantine/src/Feature";

type PaymentActivityFeatures = Partial<
  Pick<
    Features,
    | "payment_activity"
    | "business_banking"
    | "ach_payments"
    | "ach_payments_collect"
    | "bulk_payments"
    | "wires"
    | "international_wires"
    | "ach_file_import"
  >
>;

export const canShowPaymentActivity = (
  features: PaymentActivityFeatures | null | undefined
) => {
  if (!features) {
    return false;
  }

  if (features.payment_activity) {
    return true;
  }

  return Boolean(features.business_banking && features.bulk_payments);
};

export const canShowIndividualPaymentActivity = (
  features: PaymentActivityFeatures | null | undefined
) => {
  if (!features) {
    return false;
  }

  return Boolean(features.payment_activity);
};
